export class NamedColor {
    name: string;
    color: string;

    constructor(color: string, name: string) {
        this.name = name;
        this.color = color;
    }
}

export function colorName(color: string): string {
    const palette = Palette();
    return palette.find(c => c.color === color)?.name || color;
}

// Full palette of standardized colors.
// Keep all colors lowercased.
export function Palette(): NamedColor[] {
    return [
        new NamedColor("#780700","Mørk oker"),
        new NamedColor("#aa3b17","Kraftig oker"),
        new NamedColor("#fe975d","Lys oker"),
        new NamedColor("#ffc896","Pastell oker"),
        new NamedColor("#003546","Mørk turkis"),
        new NamedColor("#007d85","Kraftig turkis"),
        new NamedColor("#00dacd","Lys turkis"),
        new NamedColor("#7cffe7","Pastell turkis"),
        new NamedColor("#29269f","Mørk blå"),
        new NamedColor("#3e59e7","Kraftig blå"),
        new NamedColor("#599cff","Lys blå"),
        new NamedColor("#7cc0ff","Pastell blå"),
        new NamedColor("#56008b","Mørk fiolett"),
        new NamedColor("#8619dc","Kraftig fiolett"),
        new NamedColor("#c27ff6","Lys fiolett"),
        new NamedColor("#e3c0ff","Pastell fiolett"),
        new NamedColor("#5a093a","Mørk rosa"),
        new NamedColor("#960a4d","Kraftig rosa"),
        new NamedColor("#d8046a","Lys rosa"),
        new NamedColor("#ff4588","Pastell rosa"),
        new NamedColor("#2e2e2e","Mørk grå"),
        new NamedColor("#5f5f5f","Kraftig grå"),
        new NamedColor("#bebebe","Lys grå"),
        new NamedColor("#dfdfdf","Pastell grå"),
    ]
}
